import AcceleratedPromoInfo from 'components/RichProfile/MyAccount/AutoReplenishment/SubscriptionItem/components/AcceleratedPromoInfo/AcceleratedPromoInfo';

export default AcceleratedPromoInfo;
